module.exports = __webpack_public_path__ + "media/src/images/favicons/favicon-16x16-37472dc364ced8f10074e9baa72a8604.png";